module.exports = __webpack_public_path__ + "static/media/down-arrow-black.71574f0c.svg";